<template>
  <v-app>
    <Navbar></Navbar>
    <v-main>
      <v-container >
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Navbar from '../Navbar/navbar.vue';

export default {
  name: 'law-view',
  components: {
    Navbar,
  },
};
</script>
